import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react/require-default-props */

/*
 * @Author: wangshengqiang
 * @Date: 2022-02-24 16:19:17
 * @LastEditTime: 2022-03-21 10:33:39
 * @LastEditors: wangshengqiang
 * @Description:
 */
// import Module from '@C/Module';
import React, { createContext, useContext, useReducer, useState } from 'react'; // import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import Form, { createForm, formShape } from './Form';
import Renderer from './Render';
import Trial from './Trial'; // import Page from './Page';

const PageViewCtx = /*#__PURE__*/createContext();
export const PageViewProvider = ({
  children,
  bg
}) => {
  const localCache = useReducer((s, n) => _objectSpread(_objectSpread({}, s), n), {});
  const bottomItems = useState(0);
  return /*#__PURE__*/React.createElement(PageViewCtx.Provider, {
    value: {
      bg,
      localCache,
      bottomItems
    }
  }, children);
};
export const usePageView = () => {
  return useContext(PageViewCtx);
};

class PageView extends React.Component {
  constructor(...args) {
    super(...args);

    this.handleModuleClick = e => {
      const activeModuleId = +e.currentTarget.dataset.id;

      if (this.props.activeModuleId !== activeModuleId) {
        this.props.postMessage({
          type: 'activeModuleId',
          data: activeModuleId
        });
        this.props.setState({
          activeModuleId
        });
      }
    };
  }

  renderContent() {
    // const { activeModuleId } = this.props;
    const {
      pageJson
    } = this.props || {};
    const {
      moduleList = []
    } = pageJson;
    return /*#__PURE__*/React.createElement(Renderer, {
      components: moduleList
    });
  }

  render() {
    var _this$props$pageJson;

    // console.log('this.props: ', this.props);
    const {
      form
    } = this.props;

    if ((_this$props$pageJson = this.props.pageJson) !== null && _this$props$pageJson !== void 0 && _this$props$pageJson.label) {
      var _this$props$pageJson2;

      document.title = (_this$props$pageJson2 = this.props.pageJson) === null || _this$props$pageJson2 === void 0 ? void 0 : _this$props$pageJson2.label;
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "page-view"
    }, /*#__PURE__*/React.createElement(Form, {
      form: form
    }, /*#__PURE__*/React.createElement(Trial, null, /*#__PURE__*/React.createElement("div", null, this.renderContent()))));
  }

}

PageView.propTypes = {
  form: formShape // postMessage: PropTypes.func,
  // pageJson: PropTypes.object,
  // activeModuleId: PropTypes.number,
  // setState: PropTypes.func,

};
export default connect(state => {
  return {// configJson: state.configJson,
    // currentPage: state.currentPage,
  };
})(createForm({
  onFieldsChange: (props, changedFields, allFields) => {// console.log('onFieldsChange  props', props);
    // console.log('onFieldsChange  changedFields', changedFields);
    // console.log('onFieldsChange  allFields', allFields);
  },
  onValuesChange: (props, changeValue, allValue) => {
    // console.log('onValuesChange props: ', props);
    // console.log('onValuesChange changeValue: ', changeValue);
    // console.log('onValuesChange allValue: ', allValue);
    const {
      dispatch: _dispatch
    } = props;

    _dispatch({
      type: 'setFormValue',
      payload: _objectSpread({}, changeValue)
    });
  }
})(PageView));